<template>
    <div id="teamInvitationPage" :class="'popupPage anim'+ ( open ? ' open' : '' )">
        <div v-if="open" class="container h-100">
            <div class="row h-100">
                <div class="col-md-6 h-100 m-auto text-center d-flex flex-column">
                    <div class="header mb-3">
                        <h3 class="m-auto">{{ $t('team.my_invitation_title') }}</h3>
                        <a @click.prevent="hide();btnSfx();" href="#" class="close"></a>
                    </div>

                    <div class="d-flex justify-content-center my-4">
                        <img src="/images/home/teams/search-team-bg.png" class="vh-10" />
                    </div>

                    <h5 class="text-orange mb-0" v-html="$t('team.my_invitation_desc')"></h5>

                    <div class="create-request-list">
                        <ul v-if="invitations.length > 0" class="team-list">
                            <li v-for="r in invitations" :key="r.id">
                                <h5 class="mb-0 ml-3">{{ r.team.name }}</h5>
                                <div class="team-list__right">
                                    <span class="memberCount">
                                        <img src="/images/icon-frends.png"/> <b>{{ r.team.memberCount }}</b>
                                    </span>
                                    <span class="denyInvitation">
                                        <b-button @click="deny(r);btnSfx();" size="sm" variant="danger">
                                            <i class="fas fa-times"></i>
                                        </b-button>
                                    </span>
                                    <span class="acceptInvitation">
                                        <b-button @click="accept(r);btnSfx();" size="sm" variant="success">
                                            <i class="fas fa-check"></i>
                                        </b-button>
                                    </span>
                                </div>
                            </li>
                        </ul>
                        <div v-else class="d-flex flex-fill p-3">
                            <span class="text-primary m-auto" v-html="$t('team.my_invitation_list_empty')"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue'

import api from '../../api'


const InvitationPopup = Vue.component('team-invitation-popup', {
    data() {
        return {
            open: false,
            invitations: [],
        }
    },
    methods:{
        btnSfx(){
            this.$store.dispatch('sound/sfx','Button');
        },

        show() {
            this.open = true;
            this.invitations = [];
            this.loadData();
        },
        
        hide() {
            this.open = false;
            this.$emit("hasInvitations", this.invitations.length > 0);
        }, 

        loadData(page){
            const $this = this;
            api.teamsInvitations(1, 60)
            .then(res => {
                $this.page = page;
                $this.invitations = res.data;
            })
            .catch(err => {
                api.baseErrorHendler(err);
            });
        },

        accept(inv) {
            const $this = this;
            this.$bvModal.msgBoxConfirm(this.$t('team.my_invitation_confirm_popup_text', { name: inv.team.name }), {
                title: this.$t('team.my_invitation_confirm_popup_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: this.$t('team.my_invitation_confirm_popup_confirm_btn'),
                cancelTitle: this.$t('base.btn_cancel'),
                modalClass: 'confirmModal',
                okVariant: 'primary',
                hideHeaderClose: false,
                centered: true,
            })
            .then(value => {
                if(value){
                    api.teamsAcceptInvitations(inv.id)
                    .then(res => {
                        $this.$store.dispatch('auth/getMe');
                        $this.hide();
                    })
                    .catch(err => {
                        api.baseErrorHendler(err);
                    });
                }
            })
            .then(value => {
                $this.$store.dispatch('sound/sfx','Button');
            });
        },

        deny(inv) {
            const $this = this;
            api.teamsDenyInvitations(inv.id)
            .then(res => {
                $this.invitations = $this.invitations.filter(x => x.id != inv.id);
            })
            .catch(err => {
                api.baseErrorHendler(err);
            });
        }
    },
    watch: {
        open(){
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
            document.body.scrollTop = 0; // For Safari
            if(this.open) document.body.classList.add("lock");
            else document.body.classList.remove("lock");
        }
    }
})

export default InvitationPopup
</script>